import { ShiftProfilesGroupsTable } from 'components/table/shift_profiles_groups/Table';

const GroupShiftProfile = () => {
    return (
        <div style={{ display: 'flex', flexDirection: 'column', height: '100%', minHeight: 0 }}>
            <h1 style={{ margin: '0 0 16px 0' }}>Grupo de Perfiles de Turno</h1>
            <div style={{ flex: 1, minHeight: 0 }}>
                <ShiftProfilesGroupsTable />
            </div>
        </div>
    );
}

export { GroupShiftProfile };